import Reflux from "reflux";
// triggered by the store
export const LoginStoreActions = {
	LoginCompleted: Reflux.createAction(["LoginCompleted"]),
	LoginStateChanged: Reflux.createAction(["LoginStateChanged"]),
};
